
import { useEffect } from 'react';
import Navigation from '../../components/feature/Navigation';
import Footer from '../../components/feature/Footer';
import DealershipHero from './components/DealershipHero';
import DealershipBenefits from './components/DealershipBenefits';
import DealershipProducts from './components/DealershipProducts';
import DealershipProcess from './components/DealershipProcess';
import DealershipInvestment from './components/DealershipInvestment';
import DealershipSupport from './components/DealershipSupport';
import DealershipFAQ from './components/DealershipFAQ';

const DealershipPage = () => {
  useEffect(() => {
    // Update page title and meta description for dealership page
    document.title = 'Alabama Glamping Dealership Opportunities - Start Your Business | OED Glamping';
    
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', 'Start your glamping dealership business in Alabama with OED Glamping. Comprehensive support, proven products, and profitable opportunities in the growing eco-tourism industry. Apply today.');
    }

    const metaKeywords = document.querySelector('meta[name="keywords"]');
    if (metaKeywords) {
      metaKeywords.setAttribute('content', 'Alabama glamping dealership opportunities, glamping business franchise, eco-tourism dealership, outdoor hospitality business');
    }

    // Update social media images
    const ogImage = document.querySelector('meta[property="og:image"]');
    if (ogImage) {
      ogImage.setAttribute('content', 'https://public.readdy.ai/ai/img_res/bdc1bab4cea0465a47e0effd4061f112.jpg');
    }

    const twitterImage = document.querySelector('meta[property="twitter:image"]');
    if (twitterImage) {
      twitterImage.setAttribute('content', 'https://readdy.ai/api/search-image?query=Professional%20business%20handshake%20with%20glamping%20structures%20in%20Alabama%20background%2C%20dealership%20partnership%20opportunity%20visualization%2C%20modern%20eco-friendly%20accommodations%20display%2C%20successful%20business%20collaboration%20in%20outdoor%20hospitality%20industry&width=1200&height=630&seq=dealership-twitter&orientation=landscape');
    }

    // Add BusinessOpportunity Schema.org JSON-LD
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.textContent = JSON.stringify({
      "@context": "https://schema.org",
      "@type": "BusinessOpportunity",
      "name": "Alabama Glamping Dealership Opportunities",
      "description": "Start your glamping dealership business in Alabama with OED Glamping. Comprehensive support, proven products, and profitable opportunities in the growing eco-tourism industry.",
      "url": `${import.meta.env.VITE_SITE_URL || 'https://example.com'}/dealership`,
      "provider": {
        "@type": "Organization",
        "name": "OED Glamping"
      },
      "businessFunction": "Dealership Opportunity",
      "areaServed": {
        "@type": "Place",
        "name": "Alabama"
      }
    });
    document.head.appendChild(script);

    return () => {
      const existingScript = document.querySelector('script[type="application/ld+json"]');
      if (existingScript && existingScript.textContent?.includes('BusinessOpportunity')) {
        document.head.removeChild(existingScript);
      }
    };
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Navigation />
      <main>
        <header>
          <h1 className="sr-only">Alabama Glamping Dealership Opportunities</h1>
          <DealershipHero />
        </header>
        <section aria-label="Dealership Benefits">
          <DealershipBenefits />
        </section>
        <section aria-label="Dealership Products">
          <DealershipProducts />
        </section>
        <section aria-label="Dealership Process">
          <DealershipProcess />
        </section>
        <section aria-label="Investment Information">
          <DealershipInvestment />
        </section>
        <section aria-label="Dealership Support">
          <DealershipSupport />
        </section>
        <section aria-label="Frequently Asked Questions">
          <DealershipFAQ />
        </section>
      </main>
      <Footer />
    </div>
  );
};

export default DealershipPage;
